import { Sparkles, AlertTriangle } from 'lucide-react';
import SectionHeader from './SectionHeader';
import { PANCHANG_TRANSLATIONS } from "../../../../languages/panchang";

interface TimingsSectionProps {
    auspiciousTimings: any;
    inauspiciousTimings: any;
    formatTime: (time: string | null | undefined) => string;
    language: string;
}

const TimingRow = ({ label, value, isAuspicious = true, formatTime, language }: any) => {
    // Format value - handle objects with {from, to} structure and convert to AM/PM
    const formatValue = (val: any): string => {
        if (!val) return '---';
        if (typeof val === 'string') return formatTime(val);
        if (typeof val === 'object' && val.from && val.to) {
            const fromTime = formatTime(val.from);
            const toTime = formatTime(val.to);
            if (language === 'hindi') {
                return `${fromTime} से ${toTime} तक`;
            }
            return `${fromTime} to ${toTime}`;
        }
        return '---';
    };

    return (
        <div className="flex justify-between items-center py-3 border-b border-white/20 last:border-0 hover:bg-white/5 px-2 rounded-lg transition-colors">
            <span className="text-purple-200/80 text-sm font-medium font-sans">{label}</span>
            <span className={`text-sm font-bold font-sans ${isAuspicious ? 'text-green-400' : 'text-red-400'}`}>
                {formatValue(value)}
            </span>
        </div>
    );
};

const TimingsSection = ({ auspiciousTimings, inauspiciousTimings, formatTime, language }: TimingsSectionProps) => {
    const langKey = language === 'hindi' ? 'Hindi' : 'English';
    const t = PANCHANG_TRANSLATIONS[langKey];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Auspicious */}
            <div className="bg-white/[0.08] border border-white/20 rounded-2xl p-6 shadow-xl">
                <SectionHeader icon={Sparkles} title={t.auspiciousTimings} className="mb-4" />
                <div className="space-y-1">
                    {auspiciousTimings &&
                        Object.entries(auspiciousTimings).map(([key, val]: any) => (
                            <TimingRow key={key} label={key} value={val} isAuspicious={true} formatTime={formatTime} language={language} />
                        ))}
                </div>
            </div>

            {/* Inauspicious */}
            <div className="bg-white/[0.08] border border-white/20 rounded-2xl p-6 shadow-xl">
                <SectionHeader icon={AlertTriangle} title={t.inauspiciousTimings} className="mb-4" />
                <div className="space-y-1">
                    {inauspiciousTimings &&
                        Object.entries(inauspiciousTimings).map(([key, val]: any) => (
                            <TimingRow key={key} label={key} value={val} isAuspicious={false} formatTime={formatTime} language={language} />
                        ))}
                </div>
            </div>
        </div>
    );
};

export default TimingsSection;
